/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';
import some from 'lodash/some'

import { Button } from 'primereact/button';
import { RadioButton } from 'primereact/radiobutton';
import { Checkbox  } from 'primereact/checkbox';

import { SET_VALUES_SECTION } from '@constants/actionType';

import store from '@store';

class VisibilityForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      optionCountriesVisible: [],
      isAllCountriesVisible: false,
      errors: []
    };
  }

  componentDidMount() {
    const {
      keysLenguages,
      _visibility,
      i18n
    } = this.props;
    if (_visibility) {
      this.setState({
        optionCountriesVisible: _visibility.optionCountry,
        isAllCountriesVisible: _visibility.isAllCountriesVisible
        // ..._visibility
      });
    }
    this.setState({ loadingPage: false });
  }



  onChange = ({ target }) => {
    const [language, name] = target.name.split('-');
    this.setState((prevState) => ({
      [language]: { ...prevState[language], [name]: target.value },
    }));
  };

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  validateFields = async () => {
    const { isAllCountriesVisible, optionCountriesVisible } = this.state
    let errors = {}
    if (!isAllCountriesVisible && !optionCountriesVisible.length ) errors = { ...errors, [`countriesSelect`]: 'countriesSelect es requerido' }
    this.setState({errors})
    return errors
  }

  onSubmit = async (e) => {
    e.preventDefault();
    let validate = await this.validateFields()
    if (some(validate, {})) return true
    const { success } = this.props;
    const { optionCountriesVisible, isAllCountriesVisible } = this.state;

    await store.dispatch({
      type: SET_VALUES_SECTION,
      payload: { visibility: {optionCountry: optionCountriesVisible, isAllCountriesVisible} },
    });
    success();
  };

  onChangeCheck = (e) => {
    const { optionCountriesVisible } = this.state
    let selectedCountry = [...optionCountriesVisible];
    if(e.checked)
      selectedCountry.push(e.value);
    else
      selectedCountry.splice(selectedCountry.indexOf(e.value), 1);

    this.setState(
      {optionCountriesVisible: selectedCountry, isAllCountriesVisible: false},
      () => this.validateFieldsOnchange(`countriesSelect`, true)
    );
  }

  onChangeAllCountries = (e) => {
    this.setState({isAllCountriesVisible: e.value, optionCountriesVisible: []}, () => this.validateFieldsOnchange(`countriesSelect`, true))
  }

  render() {
    const { t, btnSubmitLoading, onBack, countriesCatalog } = this.props;
    const {
      loadingPage,
      optionCountriesVisible,
      errors
    } = this.state;

    const isFormFieldValid = (name) =>
      !!(errors[name]);
    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );

    const renderCountruiesOption = () => countriesCatalog.map(item => (
        <div className="p-field-checkbox" key={item.label}>
          <Checkbox
            inputId={`cb${item.id}`}
            name="optionCountriesVisible"
            value={item.id}
            onChange={this.onChangeCheck}
            checked={optionCountriesVisible.indexOf(item.id) !== -1}
            className={classNames({
              'p-invalid': isFormFieldValid(`countriesSelect`),
            })}
          />
          <label >{item.label}</label>
        </div>
      ))

    if (loadingPage) return true;
    return (
      <form onSubmit={this.onSubmit} autoComplete="false">
        <div className="p-fluid p-grid p-mb-4">
          <div className="p-col-12 p-field">
              <label
                htmlFor="title"
                className={classNames('p-text-bold', {
                    'p-error': isFormFieldValid(`countriesSelect`),
                  })}
              >
                {t('Seleccione los paìses para los cuales la sección sera visible')}
              </label>
              <div className="p-field-radiobutton">
                <Checkbox
                  name="isAllCountriesVisible"
                  value={true}
                  onChange={this.onChangeAllCountries}
                  checked={this.state.isAllCountriesVisible}
                  className={classNames({
                    'p-invalid': isFormFieldValid(`countriesSelect`),
                  })}
                />
                <label>{t('Todos los países')}</label>
              </div>
              { renderCountruiesOption() }
            </div>
          </div>
        <div className="p-col-12 footer-btn">
          <div className="p-d-flex p-jc-between">
            <Button
              label={t('Cancelar')}
              type="button"
              className="p-button-secondary"
              onClick={() => onBack()}
            />
            <Button
              label={t('Continuar')}
              type="submit"
              className="p-button-primary"
              loading={btnSubmitLoading}
            />
          </div>
        </div>
      </form>
    );
  }
}

const mapStateToProps = (state) => ({
  itemsTabsLenguages: state.catalogs.tabsLanguageCatalog,
  keysLenguages: state.catalogs.keysLanguageCatalog,
  _componentsAvailables: state.section.componentsAvailables,
  _componentsSelected: state.section.componentsSelected,
  _visibility: state.section.visibility,
  countriesCatalog: state.catalogs.countriesCurrentCatalog,
});

export default compose(
  withTranslation(),
  connect(mapStateToProps, null)
)(VisibilityForm);
